<template>
  <div class="login-pass">
    <a-form :model="formState" @finish="handleFinish" @finishFailed="handleFinishFailed">
      <a-form-item>
        <a-input v-model:value="formState.username" placeholder="请输入账号"  size="large">
          <template #prefix>
            <UserOutlined style="color: rgba(0, 0, 0, 0.25)" />
          </template>
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input v-model:value="formState.password" type="password" placeholder="请输入账号"  size="large">
          <template #prefix>
            <LockOutlined style="color: rgba(0, 0, 0, 0.25)" />
          </template>
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-button
          size="large"
          class="save-btn"
          type="primary"
          html-type="submit"
          :disabled="formState.username === '' || formState.password === ''"
        >立即登录</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script setup>
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue';
import { reactive } from 'vue';
import { loginPass } from '@/common/api'
import { setLocalStorage } from '@/common/storage'
const formState = reactive({
  username: '',
  password: '',
});

const handleFinish = values => {
  console.log(values, formState);
  loginPass({
    data:{
      ...formState
    },
    success:res=>{
      setLocalStorage('accessToken',res.access_token, res.expires_in)
      window.location.href = location.origin + '/oadmin/'
    }
  })
};

const handleFinishFailed = errors => {
  console.log(errors);
};


</script>
<style lang="less" scoped>
.login-pass{
  padding-top:20px;
}
</style>